<template>
  <div class="footer">
    <div class="footer-content">
      <div class="account">
        <img v-if="bottom.code" :src="$imgUrl + bottom.code" alt />
        <h5>长按保存图片，在微信中扫描二维码</h5>
      </div>

      <div class="info">
        <h4 @touchstart="callPhone(bottomInfo.phone)">
          电话:&nbsp;&nbsp;{{ bottomInfo.phone }}
        </h4>
        <p>{{ bottomInfo.url }}</p>
      </div>
      <div class="logo">
        <img v-if="bottom.logo" :src="bottomData.logo_image" alt />
      </div>

      <div class="copy">
        <p @click="footBar">ICP证号 ©粤ICP备14001464号</p>
        <p>{{ bottomData.copyright }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer",
  props: {
    bottom: Object,
    bottomInfo: Object,
  },
  data() {
    return {
      bottomData:{}
    };
  },
  mounted() {
    this.getSundry();
  },
  methods: {
    getSundry() {
      this.$http.post(
        "https://eartisanapplets.wsandos.com/api/index/sundry",
        null,
        (res) => {
          if (res.code == 1) {
            this.bottomData = res.data;
            this.getJssdk(window.location.href, {
              title: res.data.share_title,
              desc: res.data.share_detail,
              imgUrl: res.data.share_image,
            });
          }
        }
      );
    },
    // 点击跳转外链
    footBar() {
      window.location.href = "http://www.beian.miit.gov.cn/";
    },
    callPhone(phone) {
      window.location.href = "tel://" + phone;
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~styles/varible.styl';

.footer {
  color: #fff;
  background: #0F1219;
  height: 500px;

  .footer-content {
    // padding: 10.7% 0 4% 5%;
    // box-sizing: border-box;
    // width: 100%;
    overflow:hidden;
    .logo, .info, .account {
      font-size: 0.2rem;

      li {
        line-height: 1em;
        font-weight: 600;
      }

      li:first-of-type {
        font-size: 0.3rem;
        line-height: 1em;
        font-weight: 600;
        margin-bottom: 0.4em;
        width: 100% !important;
      }
    }

    .logo {
      width: 81px;
      margin-top: 19%;
      margin-left: 38%;
      position: relative;

      img {
        position: relative;
        width: 100%;
      }
    }

    .logo::before {
      content: '';
      position: absolute;
      top: 14px;
      left: -130px;
      width: 109px;
      height: 1px;
      background: #272A33;
    }

    .logo::after {
      content: '';
      position: absolute;
      top: 14px;
      left: 100px;
      width: 109px;
      height: 1px;
      background: #272A33;
    }

    .info {
      // display: inline-block;
      width: 70%;
      color: #fefefe;
      margin-left: 15%;
      text-align: center;
      margin-top: 10%;

      h4 {
        font-size: 14px;
        font-weight: 400;
        color: #FFFFFF;
      }

      p {
        margin-top: 5%;
        font-size: 13px;
        font-weight: 400;
        color: #7E8592;
      }
    }

    .account {
      text-align: center;
      display: block;
      vertical-align: top;
      margin: 15% auto 0 auto;

      img {
        width: 100px;
      }

      h5 {
        text-align: center;
        margin-top: 8%;
        width: 200px;
        font-size: 14px;
        font-weight: 500;
        color: #7E8592;
        width: 100%;
      }
    }

    .copy {
      margin-top: 10%;
      font-size: 0.2rem;
      color: $homeColor;

      p {
        text-align: center;
        font-size: 14px;
        font-weight: 400;
        color: #7E8592;
        margin-bottom: 4%;
      }

      span {
        margin-right: 2em;
        cursor: pointer;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/mobile/Footer.vue